package fr.frux.feature.harvestcreate

import fr.frux.feature.harvestcreate.resources.Res
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_hint_baskets
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_hint_gate
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_hint_path
import org.jetbrains.compose.resources.StringResource

/** Consignes d'arrivée proposées au propriétaire qui accueille chez lui (artboard RecolteSurLieu). */
enum class AccessHint(
    val textRes: StringResource,
) {
    GATE(Res.string.harvestcreate_site_hint_gate),
    PATH(Res.string.harvestcreate_site_hint_path),
    BASKETS(Res.string.harvestcreate_site_hint_baskets),
}
